var map = {
	"./auth/client/lang/client.zh.js": "OwpP",
	"./auth/menu/lang/menu.zh.js": "qtes",
	"./auth/pageOp/lang/pageOp.zh.js": "8nTJ",
	"./auth/permission/lang/permissions.zh.js": "wdx8",
	"./auth/role/lang/role.zh.js": "jWB2",
	"./auth/user/lang/user.zh.js": "yU40",
	"./financial/orderLocking/lang/orderLocking.zh.js": "mt3B",
	"./home/lang/home.zh.js": "JRhZ",
	"./md/market/lang/market.zh.js": "wv6A",
	"./zhubo/finance/lang/finance.zh.js": "QOxW",
	"./zhubo/orderQuery/lang/orderQuery.zh.js": "C4pU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NMad";


//////////////////
// WEBPACK FOOTER
// ./src/page \.zh.js$
// module id = NMad
// module chunks = 87